import React, { useEffect, useState,useRef } from "react";
import AxiosInstance from '../AxiosInstance';
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "./Layout";
import { Button } from "react-bootstrap";
import { ArrowLeftCircle,PencilSquare  } from "react-bootstrap-icons";
import 'bootstrap-icons/font/bootstrap-icons.css';
import DownloadProfileButton from "./DownloadProfileButton";
import Accordion from 'react-bootstrap/Accordion';
import ToastNotification from "../ToastNotification";

const EmployeeDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user_id } = location.state;
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const imageUrl = process.env.REACT_APP_BASE_URL + '/uploads/';
  const [copied, setCopied] = useState(false);
  const toastRef = useRef(null);
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await AxiosInstance.get(
          `/common/api/user-details/${user_id}`
        );
        setProfile(response.data);
        setLoading(false);
      } catch (error) {
        toastRef.current?.showToast("Error fetching profile.", "danger");
        setLoading(false);
      }
    };
    fetchProfile();
  }, [user_id]);
  
  if (loading) {
    return (
      <Layout>
        <div className="container my-5 text-center">
          <h3>Loading employee details...</h3>
        </div>
      </Layout>
    );
  }

  if (!profile) {
    return (
      <Layout>
        <div className="container my-5 text-center">
          <h3>Employee not found or an error occurred.</h3>
          <Button className="btn btn-secondary" onClick={() => navigate(-1)}>
            <ArrowLeftCircle /> 
          </Button>
          <Button className="btn btn-primary mb-3" onClick={() => navigate('/editemployeedata')}>
              Edit
        </Button>        
        </div>
      </Layout>
    );
  }

  const {
    image_profile,
    first_name,
    middle_name,
    last_name,
    about,
    date_of_birth,
    permanent_building_no,
    permanent_locality,
    permanent_landmark,
    permanent_city,
    permanent_state,
    permanent_pincode,
    permanent_country,
    communication_building_no,
    communication_locality,
    communication_landmark,
    communication_city,
    communication_state,
    communication_pincode,
    communication_country,
    gender,
    department_name,
    designation_name,
    date_of_join,
    email,
    phone_number,
    education,
    social_media_links,
    emergency_contact,
    employee_code,
    manager_first_name,
    manager_middle_name,
    manager_last_name,
  } = profile;

  const formatValue = (value) => value || "Not Provided";

  const parseJSONSafely = (jsonString) => {
    try {
      if (
        !jsonString ||
        jsonString === "Not provided" ||
        jsonString === "undefined" ||
        jsonString === "null"
      ) {
        return []; // or null based on your UI needs
      }
      return JSON.parse(jsonString);
    } catch (error) {
       toastRef.current?.showToast("Unknown parse error:", error, jsonString,"danger");
      return [];
    }
  };

const formatDate = (date) => {
    const d = new Date(date);
    return `${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}-${d.getFullYear()}`;
  };

  const parsedEducation = parseJSONSafely(education);
  const parsedSocialMediaLinks = parseJSONSafely(social_media_links);
  const isSameAddress =
  permanent_building_no === communication_building_no &&
  permanent_locality === communication_locality &&
  permanent_landmark === communication_landmark &&
  permanent_city === communication_city &&
  permanent_state === communication_state &&
  permanent_pincode === communication_pincode &&
  permanent_country === communication_country;

  const renderAddress = (type, building_no, locality, landmark, city, state, pincode, country) => (
    <>
      <p><strong>Building No:</strong> {formatValue(building_no)}</p>
      <p><strong>Locality:</strong> {formatValue(locality)}</p>
      <p><strong>Landmark:</strong> {formatValue(landmark)}</p>
      <p><strong>City:</strong> {formatValue(city)}</p>
      <p><strong>State:</strong> {formatValue(state)}</p>
      <p><strong>Pincode:</strong> {formatValue(pincode)}</p>
      <p><strong>Country:</strong> {formatValue(country)}</p>
    </>
  );

  const copyEmail = () => {
    navigator.clipboard.writeText(email).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500); // reset after 1.5 sec
    });
  };

  return (
    <Layout heading="Details">
            <div className="d-flex justify-content-between mb-3">
        <Button className="btn btn-secondary" onClick={() => navigate(-1)}>
          <ArrowLeftCircle className="me-1" />
        </Button>

        <Button className="btn btn-primary" onClick={() => navigate(`/edit-employee/${user_id}`)}>
          <PencilSquare className="me-1" />
          Edit
        </Button>

      </div>

      <div className="container mt-1">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10">
            <div
              className="card shadow"
              style={{ backgroundColor: "#ECECEC", textTransform: "capitalize" }}
            >
              <div className="card-body">
                <div className="d-flex flex-column flex-md-row">
                  <div className="col-12 col-md-5 p-3 text-center" style={{backgroundColor: "#ECECEC",borderRadius: "8px 8px 0 0",}}>
                      <div className="position-relative d-inline-block"style={{ width: "150px", height: "150px" }}>
                        <img
                          src={
                            image_profile
                              ? `${imageUrl + image_profile}`
                              : "https://via.placeholder.com/150"
                          }
                          alt="Profile"
                          className="rounded-circle profile-img"
                          style={{
                            width: "150px",
                            height: "150px",
                            objectFit: "cover",
                          }}
                        />
                        <div className="overlay-icon d-flex align-items-center justify-content-center">
                          <DownloadProfileButton userId={user_id} userName={first_name} />
                        </div>
                    </div>
                    <h3 className="mt-3">
                    {`${formatValue(first_name)} ${middle_name ? formatValue(middle_name) + ' ' : ''}${formatValue(last_name)}`}
                    </h3>
                    <div >
                      {formatValue(employee_code)}
                    </div>
                    <div><b className="text-muted">{formatValue(department_name)}</b></div>
                    {designation_name && (
                      <div><b className="text-muted">{formatValue(designation_name)}</b></div>
                    )}
                    <div><b className="text-muted"> {`${formatValue(manager_first_name)} ${manager_middle_name ? formatValue(manager_middle_name) + ' ' : ''}${formatValue(manager_last_name)}`}</b></div>

                    <div className="mt-4">
                      <h5>About</h5>
                      <p>{formatValue(about)}</p>
                    </div>

                    <div className="mt-4">
                      <div
                        className="p-3"
                        style={{
                          backgroundColor: "#f8d7da",
                          color: "black",
                          borderRadius: "5px",
                          marginTop: "10px",
                        }}
                      >
                         <p>Emergency Contact</p>
                          <b>
                            <a href={`tel:${emergency_contact}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                              {formatValue(emergency_contact)}
                            </a>
                          </b>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 col-md-7 p-3"
                    style={{
                      backgroundColor: "white",
                      borderRadius: "0 0 8px 8px",
                    }}
                  >
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <p>
                           <strong>Date of Birth:</strong> {formatDate(formatValue(date_of_birth))}
                        </p>
                        <p>
                          <strong>Gender:</strong> {formatValue(gender)}
                        </p>
                        <div className="mb-3">
                          <strong>Address:</strong>
                          <div className="w-100">
                            <Accordion className="mt-2">
                            <Accordion.Item eventKey="0">
                              <Accordion.Header>
                                <span>Permanent</span>
                              </Accordion.Header>
                              <Accordion.Body>
                                {renderAddress(
                                  "Permanent",
                                  permanent_building_no,
                                  permanent_locality,
                                  permanent_landmark,
                                  permanent_city,
                                  permanent_state,
                                  permanent_pincode,
                                  permanent_country
                                )}
                              </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                              <Accordion.Header>
                                <span>Communication</span>
                              </Accordion.Header>
                              <Accordion.Body>
                                {isSameAddress ? (
                                  <p>Same as Permanent Address</p>
                                ) : (
                                  renderAddress(
                                    "Communication",
                                    communication_building_no,
                                    communication_locality,
                                    communication_landmark,
                                    communication_city,
                                    communication_state,
                                    communication_pincode,
                                    communication_country
                                  )
                                )}
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                          </div>                      
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <p>
                          <strong>Date of Joining:</strong> {formatDate(formatValue(date_of_join))}
                        </p>
                        <p>
                          <strong>Email:</strong> {email}{" "}
                          <button
                            onClick={copyEmail}
                            type="button"
                            style={{
                              border: "none",
                              background: "transparent",
                              cursor: "pointer",
                              padding: 0,
                              marginLeft: 8,
                              verticalAlign: "middle",
                              fontSize: "1.1rem",
                              color: copied ? "green" : "inherit",
                            }}
                            title="Copy Email"
                            aria-label="Copy email to clipboard"
                          >
                            <i className={copied ? "bi bi-check-lg" : "bi bi-copy"}></i>
                          </button>
                        </p>
                        <p>
                          <strong>Phone Number:</strong>{" "}
                          <a href={`tel:${phone_number}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                            {formatValue(phone_number)}
                          </a>
                        </p>
                      </div>
                    </div>
                    <div className="mt-4">
                      <h5>Education</h5>
                      {parsedEducation.length > 0 ? (
                        <ul>
                          {parsedEducation.map((edu, index) => (
                            <li key={index}>
                              <p>
                                <strong>Course Name:</strong> {edu.degree}
                              </p>
                              <p>
                                <strong>Institute:</strong> {edu.institute}
                              </p>
                              <p>
                                <strong>Year:</strong> {edu.year}
                              </p>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p>Not Provided</p>
                      )}
                    </div>

                    <div className="mt-4">
                      <h5>Social Media Links</h5>
                      {parsedSocialMediaLinks.length > 0 ? (
                        <ul>
                          {parsedSocialMediaLinks.map((link, index) => (
                            <li key={index}>
                              <a href={link.url} target="_blank" rel="noopener noreferrer">
                                {link.platform}
                              </a>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p>Not Provided</p>
                      )}
                    </div>

                   {/* 📂 Documents Section */}
                    <div className="mt-4">
                      <h5>Documents</h5>
                      <ul style={{ paddingLeft: "20px" }}>
                        <li>
                          <span
                            style={{
                              color: "rgba(var(--bs-link-color-rgb), var(--bs-link-opacity,1))",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => navigate("/document-upload", { state: { userId: user_id } })}
                          >
                            Manage Documents
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              color: "rgba(var(--bs-link-color-rgb), var(--bs-link-opacity,1))",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => navigate("/remarks", { state: { userId: user_id } })}
                          >
                            Manage Remarks
                          </span>
                        </li>
                      </ul>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastNotification ref={toastRef} />
      </div>
    </Layout>
  );
};

export default EmployeeDetails;
